import React from "react";
import { Routes, Route } from "react-router-dom";
import { hasPermission } from "../utils/permissionUtils";
import Products from "../pages/Pawn/Products/AllProduct";
import BorrowItems from "../pages/Pawn/Products/BorrowItems";
import BuyItems from "../pages/Pawn/Products/BuyItems";
import OverdueBorrowItems from "../pages/Pawn/Products/OverdueBorrowItems";
import OverduePawnItems from "../pages/Pawn/Products/OverduePawnItems";
import ReadyItems from "../pages/Pawn/Products/ReadyItems";
import SoldItems from "../pages/Pawn/Products/SoldItems";
import SellOnConsignmen from "../pages/Pawn/List/SellOnConsignmen";
import ListByCustomer from "../pages/Pawn/List/ListByCustomer";
import Bin from "../pages/Pawn/List/Bin";
import RedemptionItems from "../pages/Pawn/List/RedemptionItems";
import SettingPrice from "../pages/Pawn/List/SettingPrice";
import CustomerList from "../pages/Pawn/List/CustomerList";
import Inventory from "../pages/Pawn/Report/Inventory";
import IncomeExpenes from "../pages/Pawn/Report/IncomeExpenses";
import Interest from "../pages/Pawn/Report/Interest";
import ImportData from "../pages/Pawn/ImportRetrospectiveData/ImportData";
import ImportInformationBuy from "../pages/Pawn/ImportRetrospectiveData/ImportInformationPawn";
import ImportInformationPawn from "../pages/Pawn/ImportRetrospectiveData/ImportInformationBuy";
import ImportList from "../pages/Pawn/ImportRetrospectiveData/ImportList";
import Dashboard from "../pages/Dashboard";

const PawnRoutes = ({ role }) => {
  return (
    <Routes>
      <Route path="dashboard_pawn" element={<Dashboard />} />
      {hasPermission(role, ["admin", "AdminA", "AdminM", "owner"]) && (
        <>
          <Route path="all_product_pawn" element={<Products />} />
          <Route path="buy_items_pawn" element={<BuyItems />} />
          <Route path="ready_items_pawn" element={<ReadyItems />} />
          <Route path="borrow_items_pawn" element={<BorrowItems />} />
          <Route
            path="overdue_borrow_items_pawn"
            element={<OverdueBorrowItems />}
          />
          <Route path="sold_items_pawn" element={<SoldItems />} />
          <Route
            path="overdue_pawn_items_pawn"
            element={<OverduePawnItems />}
          />
        </>
      )}
      {hasPermission(role, ["admin", "owner", "AdminA", "AdminM"]) && (
        <>
          <Route
            path="sell_on_consignmen_pawn"
            element={<SellOnConsignmen />}
          />
          <Route path="redemption_items_pawn" element={<RedemptionItems />} />
          <Route path="setting_price_pawn" element={<SettingPrice />} />
          <Route path="list_by_customer_pawn" element={<ListByCustomer />} />
          <Route path="bin_pawn" element={<Bin />} />
          <Route path="customer_list_pawn" element={<CustomerList />} />
        </>
      )}
      {hasPermission(role, ["admin", "owner", "AdminA", "AdminM"]) && (
        <>
          <Route path="inventory_pawn" element={<Inventory />} />
          <Route path="income_expenses_pawn" element={<IncomeExpenes />} />
          <Route path="interest_pawn" element={<Interest />} />
        </>
      )}
      {hasPermission(role, ["admin", "owner", "AdminA", "AdminM"]) && (
        <>
          <Route path="import_data_pawn" element={<ImportData />} />
          <Route
            path="import_information_pawn"
            element={<ImportInformationPawn />}
          />
          <Route
            path="import_information_buy_pawn"
            element={<ImportInformationBuy />}
          />
          <Route path="import_list_pawn" element={<ImportList />} />
        </>
      )}
    </Routes>
  );
};

export default PawnRoutes;
